import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getProfileCategories() {
  return httpService.get(ApiUrl.PROFILECATEGORIES);
}

const obj = { getProfileCategories };

export default obj;
